<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <i v-if="!params.data.active" class="fas fa-circle" style="color:red;"></i>
    <i v-else class="fas fa-circle" style="color:green;"></i>
  </div>
</template>

<script>
export default {
  name: "CellRendererStatus"
};
</script>
